export default function Datenschutz() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-white">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <h1 className="text-4xl font-serif font-bold text-gray-900 mb-8">Datenschutzerklärung</h1>
        
        <div className="prose prose-lg max-w-none">
          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. Datenschutz auf einen Blick</h2>
          
          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">Allgemeine Hinweise</h3>
          <p className="mb-4">
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen 
            Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit 
            denen Sie persönlich identifiziert werden können.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">Verantwortliche Stelle</h3>
          <p className="mb-4">
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
          </p>
          <p className="mb-4">
            Love yourself beauty by Meltem<br />
            Inh. Meltem Tiryaki<br />
            Wilhelm-Strauß-Weg 2B<br />
            21109 Hamburg<br />
            <br />
            Telefon: +49 (0)40 524 794 72<br />
            E-Mail: <a href="mailto:mail@loveyourselfbeauty.de" className="text-pink-600 hover:text-pink-700">mail@loveyourselfbeauty.de</a>
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. Hosting und Server-Logs</h2>
          <p className="mb-4">
            <strong>Strato Hosting</strong><br />
            Diese Website wird bei Strato gehostet. Der Hoster speichert automatisch Informationen in 
            sogenannten Server-Log-Dateien, die Ihr Browser automatisch übermittelt. Dies sind:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Browsertyp und Browserversion</li>
            <li>Verwendetes Betriebssystem</li>
            <li>Referrer URL (zuvor besuchte Seite)</li>
            <li>Hostname des zugreifenden Rechners</li>
            <li>Uhrzeit der Serveranfrage</li>
            <li>IP-Adresse</li>
          </ul>
          <p className="mb-4">
            Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung 
            dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein 
            berechtigtes Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner Website.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. Externe Dienste und Inhalte</h2>
          
          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">Google Fonts</h3>
          <p className="mb-4">
            Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten sogenannte Google Fonts, 
            die von Google bereitgestellt werden. Beim Aufruf einer Seite lädt Ihr Browser die benötigten 
            Fonts, um Texte und Schriftarten korrekt anzuzeigen.
          </p>
          <p className="mb-4">
            Zu diesem Zweck muss der von Ihnen verwendete Browser Verbindung zu den Servern von Google 
            aufnehmen. Hierdurch erlangt Google Kenntnis darüber, dass über Ihre IP-Adresse diese Website 
            aufgerufen wurde. Die Nutzung von Google Fonts erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
          </p>
          <p className="mb-4">
            Anbieter: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland<br />
            Weitere Informationen: <a href="https://developers.google.com/fonts/faq" target="_blank" rel="noopener noreferrer" className="text-pink-600 hover:text-pink-700">Google Fonts FAQ</a>
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mt-6 mb-3">Font Awesome & Remix Icon (Cloudflare CDN)</h3>
          <p className="mb-4">
            Diese Website nutzt Icon-Fonts von Font Awesome und Remix Icon, die über Cloudflare CDN geladen werden. 
            Dabei wird Ihre IP-Adresse an Cloudflare übermittelt. Die Nutzung erfolgt auf Grundlage 
            von Art. 6 Abs. 1 lit. f DSGVO.
          </p>
          <p className="mb-4">
            Anbieter: Cloudflare, Inc., 101 Townsend St, San Francisco, CA 94107, USA<br />
            Datenschutzerklärung: <a href="https://www.cloudflare.com/privacypolicy/" target="_blank" rel="noopener noreferrer" className="text-pink-600 hover:text-pink-700">Cloudflare Privacy Policy</a>
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. Keine Verwendung von Cookies</h2>
          <p className="mb-4">
            Diese Website verwendet keine Cookies für Tracking oder Analyse-Zwecke. Technisch notwendige Cookies 
            werden nicht gesetzt.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Ihre Rechte</h2>
          <p className="mb-4">
            Sie haben jederzeit das Recht:
          </p>
          <ul className="list-disc pl-6 mb-4">
            <li>Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten zu erhalten (Art. 15 DSGVO)</li>
            <li>Die Berichtigung unrichtiger Daten zu verlangen (Art. 16 DSGVO)</li>
            <li>Die Löschung Ihrer Daten zu verlangen (Art. 17 DSGVO)</li>
            <li>Die Einschränkung der Datenverarbeitung zu verlangen (Art. 18 DSGVO)</li>
            <li>Datenübertragbarkeit zu verlangen (Art. 20 DSGVO)</li>
            <li>Der Datenverarbeitung zu widersprechen (Art. 21 DSGVO)</li>
            <li>Beschwerde bei einer Aufsichtsbehörde einzureichen (Art. 77 DSGVO)</li>
          </ul>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">6. Widerspruchsrecht</h2>
          <p className="mb-4">
            Sofern Ihre personenbezogenen Daten auf Grundlage von berechtigten Interessen gemäß Art. 6 Abs. 1 lit. f 
            DSGVO verarbeitet werden, haben Sie das Recht, gemäß Art. 21 DSGVO Widerspruch gegen die Verarbeitung 
            Ihrer personenbezogenen Daten einzulegen.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">7. Recht auf Beschwerde bei einer Aufsichtsbehörde</h2>
          <p className="mb-4">
            Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer 
            personenbezogenen Daten durch uns zu beschweren.
          </p>
          <p className="mb-4">
            Zuständige Aufsichtsbehörde:<br />
            Der Hamburgische Beauftragte für Datenschutz und Informationsfreiheit<br />
            Ludwig-Erhard-Str. 22, 20459 Hamburg<br />
            Website: <a href="https://datenschutz-hamburg.de/" target="_blank" rel="noopener noreferrer" className="text-pink-600 hover:text-pink-700">datenschutz-hamburg.de</a>
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">8. Kontakt in Datenschutzfragen</h2>
          <p className="mb-4">
            Bei Fragen zum Datenschutz können Sie sich jederzeit an uns wenden:
          </p>
          <p className="mb-4">
            Love yourself beauty by Meltem<br />
            Meltem Tiryaki<br />
            Wilhelm-Strauß-Weg 2B<br />
            21109 Hamburg<br />
            E-Mail: <a href="mailto:mail@loveyourselfbeauty.de" className="text-pink-600 hover:text-pink-700">mail@loveyourselfbeauty.de</a>
          </p>

          <p className="text-sm text-gray-600 mt-8">
            Stand dieser Datenschutzerklärung: Februar 2026
          </p>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <a href="/" className="inline-block bg-pink-600 text-white px-6 py-3 rounded-lg hover:bg-pink-700 transition-colors whitespace-nowrap">
              Zurück zur Startseite
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}